import { useEffect, useMemo } from "react";
import useHomeController from "../../controllers/Home.controllers";
import ReactGA from "react-ga4";
import RevenueChart from '../graph-charts'

const Landing = () => {
  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: "dashboard" });
  }, []);
  // custom hooks import
  const {
    booking,
    setBookingDates,
    activeBtn,
    tabBookingFilter,
    bookingSource,
    setBookingOption,
    bookingOption,
    userDetail,
    roomStatus,
    foodStatus,
    foodChart,
    foodRevenue,
    bookingChart,
    bookingRevenue,
    chartOption,
    changeSourceByOption,
    options,
    optionsFood,
    optionsBookRev,
    optionsFoodRev,



    optionsRoom,
    optionsBooking,
    optionsFoodNew,

    propertyData,
    tabFoodFilter,
    navigateBooking,
    Chart,
    RenderBox,
    foodLoading,
    bookingLoading,
    roomLoading,
    propertyLoading,
    foodSource,
    setFoodOption,
    foodOption,
    bookingStatic,
    setFoodDates,
  } = useHomeController();
  const RenderFoodSource = useMemo(() => {
    return (
      <div className="form-group">
        <select
          name="boookingOrder"
          className="form-select"
          onChange={({ target }) => {
            setFoodOption(target.value);
          }}
        >
          {foodSource.map((item) => (
            <option
              selected={item.id == foodOption}
              value={item.id}
              key={item.id}
            >
              {item.title}
            </option>
          ))}
        </select>
      </div>
    );
  }, [foodOption]);
  const RenderBookingStatus = useMemo(() => {
    return (
      <div className="form-group">
        <select
          name="boookingOrder"
          className="form-select"
          onChange={(e) => changeSourceByOption(e.target.value)}
        >
          <option selected={"All" == chartOption} value={"All"}>
            All
          </option>
          {booking.map((item, ind) => {
            const { bookingStatus } = item;
            let bookingName = bookingStatus;
            if (
              bookingStatus == "Pending" ||
              bookingStatus == "Call Not Picked"
            ) {
              return;
            }
            if (bookingStatus == "Confirmed") {
              bookingName = "Upcoming";
            }
            if (bookingStatus == "Checked-In") {
              bookingName = "In-House";
            }
            return (
              <option
                key={ind}
                selected={bookingStatus == chartOption}
                value={bookingStatus}
              >
                {bookingName}
              </option>
            );
          })}
        </select>
      </div>
    );
  }, [booking]);


  let roomChart = [
    ["Room Type", "Count"],
    ...roomStatus
      .filter((item) => item.title !== "Total")
      .map((item) => [`${item.title}: ${item.count}`, item.count])
  ];


  const filteredBookings = booking.filter((item) => {
    return (
      (bookingOption.title === "All" || item[bookingOption.count] > 0) &&
      item.bookingStatus !== "Pending" &&
      item.bookingStatus !== "Call Not Picked"
    );
  });

  const allStatuses = ["Upcoming", "In-House", "For-Checkout", "Checked-Out", "No-Show", "Cancelled", "Completed"];

  const bookingCounts = filteredBookings.reduce((acc, item) => {
    let bookingName =
      item.bookingStatus === "Confirmed"
        ? "Upcoming"
        : item.bookingStatus === "Checked-In"
          ? "In-House"
          : item.bookingStatus === "Checked-Out"
            ? "Checked-Out"
            : item.bookingStatus === "No-Show"
              ? "No-Show"
              : item.bookingStatus;

    acc[bookingName] = (acc[bookingName] || 0) + (item[bookingOption.count] || 0);
    return acc;
  }, {});

  const allBookingChart = [
    ["Booking Type", "Count"],
    ...allStatuses.map((status) => [`${status} : ${bookingCounts[status] || 0}`, bookingCounts[status] || 0]),
  ];


  const foodBookingChart = [
    ["Type", "Count"],
    ...foodStatus.map(item => [`${item.title} : ${item.count}`, item.count])
  ];
  if (foodStatus.every(item => item.count === 0)) {
    foodBookingChart.push(["No Data", 0.00001]);
  }


  const revenueData = [
    { date: '2025-03-01', revenue: 40000 },
    { date: '2025-03-02', revenue: 40500 },
    { date: '2025-03-03', revenue: 50000 },
    { date: '2025-03-04', revenue: 30000 },
    { date: '2025-03-05', revenue: 20000 },
    { date: '2025-03-06', revenue: 90000 },
    { date: '2025-03-07', revenue: 80000 },
    { date: '2025-03-08', revenue: 70000 },
    { date: '2025-03-09', revenue: 90000 },
    { date: '2025-03-10', revenue: 80000 },
  ];

  const occupancyData = [
    { date: '2025-03-01', revenue: 90000 },
    { date: '2025-03-02', revenue: 40500 },
    { date: '2025-03-03', revenue: 50000 },
    { date: '2025-03-04', revenue: 20000 },
    { date: '2025-03-05', revenue: 20000 },
    { date: '2025-03-06', revenue: 90000 },
    { date: '2025-03-07', revenue: 80000 },
    { date: '2025-03-08', revenue: 70000 },
    { date: '2025-03-09', revenue: 90000 },
    { date: '2025-03-10', revenue: 90000 },
  ];

  const paymentData = [
    { date: '2025-03-01', revenue: 40000 },
    { date: '2025-03-02', revenue: 20500 },
    { date: '2025-03-03', revenue: 10000 },
    { date: '2025-03-04', revenue: 30000 },
    { date: '2025-03-05', revenue: 20000 },
    { date: '2025-03-06', revenue: 90000 },
    { date: '2025-03-07', revenue: 80000 },
    { date: '2025-03-08', revenue: 70000 },
    { date: '2025-03-09', revenue: 90000 },
    { date: '2025-03-10', revenue: 80000 },
  ];


  // Dummy Data
  const roomsCount = [
    { id: 0, type: 'Economy', count: 10 },
    { id: 1, type: 'Elite', count: 10 },
    { id: 2, type: 'Luxe', count: 10 }
  ]
  const bookingDetail = [
    { id: 0, type: 'Economy', booked: 5 },
    { id: 1, type: 'Elite', booked: 5 },
    { id: 2, type: 'Luxe', booked: 5 },
  ]
  const roomOccupancy = roomsCount.map((item) => {
    let newData = bookingDetail.find((data) => data.type == item.type)
    return {
      type: item.type,
      total: item.count,
      booked: newData.booked,
      avail: (item.count - newData.booked),
      percentage: (newData.booked / item.count * 100)
    }
  });

  const roomAccupancyData = [
    ['Room Type', 'Occupancy'],
    ...roomOccupancy.map((item) => {
      return ([`${item.type} ${item.percentage}%`, item.percentage])
    })
  ]

  const optionRoomOccupancy = {
    title: "",
    pieHole: 0.2,
    is3D: false,
    sliceVisibilityThreshold: 0,
    pieSliceText: "label",
    pieSliceText: "percentage",
    colors: ["#0cab25", "#007bff", "#ffc107"],
    chartArea: {
      left: "0%",
      top: "15%",
      width: "90%",
      height: "80%"
    },
    legend: {
      position: "right",
      alignment: "center",
      textStyle: {
        fontSize: 14,
      },
    },
    tooltip: { showColorCode: true },
    titleTextStyle: {
      fontSize: 10
    },
  };

  return (
    <>
      <div className="chartWrapper ">
        <div className="flex">
          <div className="col-lg-4">
            <div className="column">
              <h4>Rooms Availability</h4>
              <div className="mb-3">
                <Chart
                  chartType="PieChart"
                  width="100%"
                  height="200px"
                  data={roomChart}
                  options={optionsRoom}
                />
              </div>
              <div className="text-center">
                <div className="tab-nav">
                  <button className="active">Today</button>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="column">
              <div className="flex justify-content-between">
                <h4>Bookings</h4>
                <select
                  className="form-select select-filter"
                  name="boookingOrder"
                  onChange={({ target }) =>
                    setBookingOption(bookingSource.find(item => item.title === target.value))
                  }
                >
                  {bookingSource.map((item, key) => (
                    <option key={key} value={item.title}>
                      {item.title}
                    </option>
                  ))}
                </select>
              </div>
              <div className="mb-3">
                <Chart
                  chartType="PieChart"
                  width="100%"
                  height="200px"
                  data={allBookingChart}
                  options={optionsBooking}
                />
              </div>
              <div className="text-center">
                <div className="timeTabDashboard tab-nav">
                  {tabBookingFilter.map((item, ind) => {
                    const { title, start, end } = item;
                    return (
                      <button
                        key={ind}
                        className={activeBtn.booking === title && "active"}
                        onClick={() => setBookingDates(start, end, title)}
                      >
                        {title}
                      </button>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="column">
              <div className="flex justify-content-between">
                <h4>Room Occupancy</h4>
              </div>
              <div className="box">
                <Chart
                  chartType="PieChart"
                  width="100%"
                  height="200px"
                  data={roomAccupancyData}
                  options={optionRoomOccupancy}
                />
              </div>
            </div>
          </div>
          {/* <div className="col-lg-4">
            <div className="column">
              <h4>Food Orders</h4>
              <div className="mb-3">
                <Chart
                  chartType="PieChart"
                  width="100%"
                  height="200px"
                  data={foodBookingChart}
                  options={optionsFoodNew}
                />
              </div>
              <div className="text-center">
                <div className="timeTabDashboard tab-nav">
                  {tabFoodFilter.map((item, ind) => {
                    const { title, start, end } = item;
                    return (
                      <button
                        key={ind}
                        className={activeBtn.foodTab === title && "active"}
                        onClick={() => setFoodDates(start, end, title)}
                      >
                        {title}
                      </button>
                    );
                  })}
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </div>
      {/* <div className="revenueWrapper">
        <div className="flex">
          <div className="col-lg-4">
            <RevenueChart title="Monthly Revenue" graphData={revenueData} />
          </div>
          <div className="col-lg-4">
            <RevenueChart title="Monthly Occupancy" graphData={occupancyData} />
          </div>
          <div className="col-lg-4">
            <RevenueChart title="Payment Summary" graphData={paymentData} />
          </div>
        </div>
      </div> */}
    </>
  );
};

export default Landing;
